// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportsRoot.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!function () {

  var React = require('react');
  var Reports = require('./Izenda.Reports');
  var ReportsStore = require('logic/Izenda.ReportsStore');
  var SubscribedInstancesStore = require('logic/Izenda.SubscribedInstancesStore');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  var routeUtils = require('share/utils/Izenda.RouteUtils');
  var uiState = require('logic/Izenda.UiState');

  var ReportsContainer = connect()(React.createClass({
    componentWillMount: function () {
      // License is expired, navigate to Settings pages
      if (uiState.expiredLicense) {
        var settingLink = routeUtils.getSettingsUrl();
        this.props.router.push(settingLink);
      }

      this.store = new ReportsStore();
      this.reportSubscriptionStore = new SubscribedInstancesStore();
    },
    render: function () {
      return !uiState.expiredLicense &&
             (<Reports {...this.props}
                       store={this.store}
                       reportSubscriptionStore={this.reportSubscriptionStore}/>);
    }
  }));

  module.exports = {
    Component: Reports,
    Store: ReportsStore,
    Container: ReportsContainer
  };
}();



// WEBPACK FOOTER //
// ./ui/modules/Reports/Izenda.ReportsRoot.jsx